import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FaCheckCircle, FaEnvelope, FaRocket } from 'react-icons/fa';
import { useNavigate, useSearchParams } from 'react-router-dom';

const PaymentSuccess = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('session_id');

    useEffect(() => {
        // You could verify the session with your backend here
        if (!sessionId) {
            navigate('/pricing');
        }
    }, [sessionId, navigate]);

    return (
        <Container className="py-5">
            <Row className="justify-content-center">
                <Col lg={8} md={10}>
                    <Card className="border-0 shadow-lg text-center p-5">
                        <Card.Body>
                            <FaCheckCircle 
                                style={{fontSize: '5rem', color: '#28a745'}} 
                                className="mb-4"
                            />
                            <h1 className="display-4 mb-4">Payment Successful!</h1>
                            <p className="lead mb-4">
                                Thank you for subscribing to agenti.quest! Your payment has been processed successfully.
                            </p>
                            
                            <div className="bg-light rounded p-4 mb-4">
                                <Row>
                                    <Col md={6} className="mb-3 mb-md-0">
                                        <FaEnvelope style={{fontSize: '2rem', color: '#667eea'}} className="mb-2" />
                                        <h5>Check Your Email</h5>
                                        <p className="text-muted mb-0">
                                            We've sent a confirmation email with your receipt and subscription details.
                                        </p>
                                    </Col>
                                    <Col md={6}>
                                        <FaRocket style={{fontSize: '2rem', color: '#667eea'}} className="mb-2" />
                                        <h5>Start Exploring</h5>
                                        <p className="text-muted mb-0">
                                            Your daily AI tool digest will arrive in your inbox every morning!
                                        </p>
                                    </Col>
                                </Row>
                            </div>

                            <div className="d-grid gap-3 d-md-flex justify-content-md-center">
                                <Button 
                                    variant="primary" 
                                    size="lg"
                                    onClick={() => navigate('/welcome')}
                                >
                                    Go to Dashboard
                                </Button>
                                <Button 
                                    variant="outline-secondary" 
                                    size="lg"
                                    onClick={() => navigate('/')}
                                >
                                    Browse AI Tools
                                </Button>
                            </div>

                            <div className="mt-5 pt-4 border-top">
                                <h5 className="mb-3">What's Next?</h5>
                                <ul className="list-unstyled text-start" style={{maxWidth: '500px', margin: '0 auto'}}>
                                    <li className="mb-2">✅ Your subscription is now active</li>
                                    <li className="mb-2">📧 Daily AI tool digest starts tomorrow</li>
                                    <li className="mb-2">🎯 Access all premium features immediately</li>
                                    <li className="mb-2">💬 Priority support available 24/7</li>
                                </ul>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default PaymentSuccess;
